export function getModalMaskClassName(visible: boolean, extraClassName = '') {
  return [
    'fixed inset-0 bg-black/50 transition-opacity duration-300 ease-out',
    visible ? 'opacity-100' : 'opacity-0',
    extraClassName,
  ]
    .filter(Boolean)
    .join(' ');
}
